import React from 'react';
import Image from '@src/components/atoms/safe-image';

import GoldenPropertyRounded from 'public/png/golden-property-rounded.png';

const BadgeGolderProperty = () => {
  return (
    <div className="flex items-center gap-2 rounded-xs">
      <Image 
        src={GoldenPropertyRounded} 
        alt="Golden Property" 
        width={50}
        height={50}
        className='w-[44.099px] h-[48px] object-contain'
      />
      <div className='flex flex-col'>
        <p className='text-[11px] leading-[15.4px] tracking-[0.11px] font-satoshi-bold text-[#252526]'>Best Choice International Property Agent</p>
        <p className='text-[11px] leading-[15.4px] tracking-[0.11px] font-satoshi text-[#686A68]'>Awarded by Golden Property Awards</p>
      </div>
    </div>
  );
};

export default BadgeGolderProperty;
